export default "__VITE_ASSET__BJhTQCQE__"